import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

    * {
      font-family: ${({ theme }) => theme.old.fonts.family.primary};
      box-sizing: border-box !important;
      margin: 0;
      padding: 0;
      outline: none;
    }

    html {
      min-height: 100dvh;
      scroll-behavior: smooth;
    }

    body {
      color:  ${({ theme }) => theme.old.colors.white};
      background-color: ${({ theme, $isPlay }) => $isPlay
        ? theme.old.colors.background.play
        : theme.old.colors.background.creators
      };
      overscroll-behavior: none;
      height: 100%;

      & > div#root {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      &::-webkit-scrollbar {
        display: none;
      }

      iframe {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 0;
      }
    }

    a {
      text-decoration: none;
      color: unset;
    }

    .animation {
      transition-property: opacity;
      transition-duration: 500ms;
    }

    .hidden {
      transition: opacity 500ms ease-in-out;
      opacity: 0;
    }

    .visible {
      transition: opacity 500ms ease-in-out;
      opacity: 1;
    }

    ::-webkit-scrollbar {
      background-color: ${props => props.theme.old.colors.lightGray};
      width: 8px;
      border-radius: ${props => props.theme.old.rounded.xl};
    }

    ::-webkit-scrollbar-thumb{
      background-color: ${props => props.theme.old.colors.gray};
      width: 8px;
      border-radius: ${props => props.theme.old.rounded.xl};
    }

    .vjs-loading-spinner{display:none!important;}

    /**
     *  Hide recaptcha badge
     */
    .grecaptcha-badge {
      display: none;
      visibility: hidden;
    }
`;